import React from 'react';

const Inventory = () => {
    return (
        <div>
            <h1>THis is Inventory section</h1>
        </div>
    );
};

export default Inventory;